import { type FC } from 'react'
import { RosterTableToolbarSlot } from './RosterTableToolbarSlot'
import { useRosterSqlSearch } from 'recruiter/hooks'

export const RosterResearchTableToolbar: FC = () => {
    const { selectedRosterIds } = useRosterSqlSearch()

    return <RosterTableToolbarSlot selectedCount={selectedRosterIds.length} />
}
